<div class="modal-header">
  <h4 class="modal-title">მენიუს რედაქტირება</h4>
  <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss()"></button>
</div>

<div class="modal-body">
 
  <div class="mb-3">
    <label for="titleInput" class="form-label">სათაური</label>
    <input type="text" id="titleInput" class="form-control" [(ngModel)]="menuItemTitle" />
  </div>

  <div class="form-check">
    <input
      type="checkbox"
      id="visibilityInput"
      class="form-check-input"
      [(ngModel)]="menuItemVisibility"
    />
    <label class="form-check-label" for="visibilityInput">გამოჩენა</label>
  </div>
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-secondary" (click)="activeModal.dismiss()">დახურვა</button>
  <button type="button" class="btn btn-primary" (click)="saveChanges()"  [disabled]="load">
    <span *ngIf="load" class="spinner-border spinner-border-sm" role="status" ></span>
    შენახვა
  </button>
</div>
